var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.25,
    height: 16.25,
    viewBox: "0 0 16.25 16.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1d0e3d;stroke:#1d0e3d;stroke-width:0.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.125 0.125)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,15.306A7.306,7.306,0,1,1,15.306,8,7.314,7.314,0,0,1,8,15.306Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.489 3.489)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M81.075,75.176H78.646V72.747A.346.346,0,0,0,78.3,72.4H75.523a.346.346,0,0,0-.347.347v2.429H72.747a.346.346,0,0,0-.347.347V78.3a.346.346,0,0,0,.347.347h2.429v2.429a.346.346,0,0,0,.347.347H78.3a.346.346,0,0,0,.347-.347V78.646h2.429a.346.346,0,0,0,.347-.347V75.523A.373.373,0,0,0,81.075,75.176Zm-.328,2.776H78.3a.346.346,0,0,0-.347.347v2.429H75.87V78.3a.346.346,0,0,0-.347-.347H73.094V75.87h2.429a.346.346,0,0,0,.347-.347V73.094h2.1v2.429a.346.346,0,0,0,.347.347h2.429Z",
    transform: "translate(-72.4 -72.4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.6a81050d57b8d26e953791086f309366.svg";
export { ForwardRef as ReactComponent };